import React from "react";
import { motion } from "framer-motion";

const QuoteTitleSlide = ({ practiceName, practiceLogo }) => {
  return (
    <div className="h-full w-full bg-[#0B1120] text-white flex flex-col items-center justify-center relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute top-0 left-0 w-[800px] h-[800px] bg-blue-600/10 rounded-full blur-[120px] -translate-x-1/2 -translate-y-1/2 pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[800px] h-[800px] bg-indigo-600/10 rounded-full blur-[120px] translate-x-1/2 translate-y-1/2 pointer-events-none" />
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-[0.03] pointer-events-none" />

      <div className="relative z-10 flex flex-col items-center text-center">
        {/* Logos */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
          className="flex items-center gap-5 mb-10"
        >
          {/* Asha logo */}
          <div className="w-16 h-16 rounded-2xl overflow-hidden shadow-xl shadow-blue-500/20">
            <img src="/assets/alogo.png" alt="Asha" className="w-full h-full object-cover" />
          </div>

          {/* X divider */}
          <span className="text-3xl font-light text-slate-500">×</span>

          {/* Practice logo or initial */}
          {practiceLogo ? (
            <div className="w-16 h-16 rounded-2xl overflow-hidden shadow-xl bg-white flex items-center justify-center">
              <img
                src={practiceLogo}
                alt={practiceName}
                className="w-full h-full object-contain p-1.5"
              />
            </div>
          ) : (
            <div className="w-16 h-16 bg-white/10 rounded-2xl flex items-center justify-center shadow-xl ring-1 ring-white/20">
              <span className="text-white font-extrabold text-2xl">
                {practiceName?.charAt(0)?.toUpperCase() || "P"}
              </span>
            </div>
          )}
        </motion.div>

        {/* Title */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2 }}
        >
          <h1 className="text-5xl md:text-6xl font-extrabold tracking-tight bg-clip-text text-transparent bg-gradient-to-b from-white to-slate-400 leading-[1.1] mb-4">
            Asha Dental AI OS
          </h1>
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="h-px w-12 bg-gradient-to-r from-transparent to-blue-500/50" />
            <span className="text-lg text-slate-400 font-medium">×</span>
            <div className="h-px w-12 bg-gradient-to-l from-transparent to-blue-500/50" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-blue-400 tracking-tight">
            {practiceName}
          </h2>
        </motion.div>

        {/* Subtitle */}
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="text-base text-slate-500 mt-8 font-medium"
        >
          Quote — prepared exclusively for your practice
        </motion.p>
      </div>
    </div>
  );
};

export default QuoteTitleSlide;
